module.exports = __webpack_public_path__ + "static/media/face1.9cb14195.jpg";